import Spinner from "../../../common/Spinner";
import classNames from "classnames";
import { STATIC_STRINGS } from "../../../utils/Constants";

const RenderLoading = () => {
  return (
    <div className={classNames("create-assessment", "card-hover", "row")}>
      <div className="col-12 h-[40%] text-neutral-dark">
        <div className="flex items-center h-full text-5xl xl:text-7xl">
          <Spinner size={20} />
        </div>
      </div>
      <div className="col-12 h-20 text-xl sm:text-base lg:text-lg xl:text-2xl xl:font-extrabold  font-bold text-primary truncate">
        {STATIC_STRINGS.PROCESSING}
      </div>
    </div>
  );
};

export default RenderLoading;
